/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Pay_Book_EstesInputs */

const en_orders_pay_book_estes = /** @type {(inputs: Orders_Pay_Book_EstesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pay + Book LTL (${i?.count})`)
};

const es_orders_pay_book_estes = /** @type {(inputs: Orders_Pay_Book_EstesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagar + reservar LTL (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Pay + Book LTL ({count})" |
*
* @param {Orders_Pay_Book_EstesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_pay_book_estes = /** @type {((inputs: Orders_Pay_Book_EstesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pay_Book_EstesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_pay_book_estes(inputs)
	return es_orders_pay_book_estes(inputs)
});